export const GENERATIVE_AI_TOOLBAR_CLASSNAME = 'generative-ai-toolbar';
